import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectIsFunnelMapEmpty } from '../../../../../reducers/united-canvas/unitedCanvasReducer';
import {
  selectIsLoadingCursor,
  selectPlacingTemplate,
  selectTransientFunnel,
} from '../../../../../reducers/canvasPageStateReducer';
import { DeprecatedZeroStateRightPanel } from './DeprecatedZeroStateRightPanel';
import { ZeroStatePanel } from './ZeroStatePanel';
import { DemoChatEntryPoint } from '../../../../../dreamforce-demo/components/DemoChatEntryPoint';
import { useFeatureToggle } from '../../../../../feature-flags/useFeatureToggle';
import { useMetadataMapping } from '../useMetadataMapping';
import { usePageHelpers } from '../usePageHelpers';
import { useCanvasFreeElementContext } from '../../../../sweep-canvas/canvas-element-tool/CanvasFreeElementContext';

export const CanvasZeroStateRouter = () => {
  const { processMiningV2, dreamforceDemo } = useFeatureToggle();
  const isFunnelMapEmpty = useSelector(selectIsFunnelMapEmpty);
  const transientFunnel = useSelector(selectTransientFunnel);
  const { funnelMapId, isLoading: isPageLoading } = usePageHelpers();
  const { clearLoadingState } = useMetadataMapping(funnelMapId || '');
  const [isOpen_deprecated, setIsOpen_deprecated] = useState(isFunnelMapEmpty);
  const { isCreatingFreeElement } = useCanvasFreeElementContext();
  const placingTemplate = useSelector(selectPlacingTemplate);
  const isLoadingCursor = useSelector(selectIsLoadingCursor);

  const onClose_deprecated = useCallback(() => {
    setIsOpen_deprecated(false);
  }, []);

  useEffect(() => {
    if (isFunnelMapEmpty) {
      setIsOpen_deprecated(true);
    } else {
      setIsOpen_deprecated(false);
    }
  }, [isFunnelMapEmpty]);

  // Handles ProcessMining cleanup cases: 1. successful completion, 2. stale/leftover
  useEffect(() => {
    if (!isFunnelMapEmpty && !!funnelMapId) {
      clearLoadingState();
    }
  }, [isFunnelMapEmpty, funnelMapId, clearLoadingState]);

  const isEmptyAndNoAction =
    isFunnelMapEmpty &&
    !transientFunnel &&
    !isPageLoading &&
    !isLoadingCursor &&
    !isCreatingFreeElement &&
    !placingTemplate;

  if (processMiningV2 && !isEmptyAndNoAction) {
    return null;
  }

  //This condition will de deleted when we remove feature toggles
  if ((dreamforceDemo || !processMiningV2) && (!isOpen_deprecated || !isEmptyAndNoAction)) {
    return null;
  }

  if (dreamforceDemo) {
    return <DemoChatEntryPoint onClose={onClose_deprecated} />;
  }

  if (processMiningV2) {
    return <ZeroStatePanel />;
  }

  return <DeprecatedZeroStateRightPanel onClose={onClose_deprecated} />;
};
